(function () {

  function maSyncLikeLabel(row) {
    var btn = row.querySelector('.ma-like-btn');
    var countEl = row.querySelector('.ma-like-count');
    if (btn && countEl && countEl.textContent) {
      var base = btn.getAttribute('aria-label') || "J'aime";
      base = base.split(' — ')[0];
      btn.setAttribute('aria-label', base + ' — ' + countEl.textContent.trim());
    }
  }

  'use strict';

  window.MassinartLikes = {};

  var WORKER_URL = 'https://lucky-unit-c87fmassinart-likes.h-ounacer.workers.dev';
  var CACHE_TTL  = 300000; // 5 min sessionStorage

  // Shared live counts for this page — updated by batch fetch and by clicks
  var liveCounts = {};

  // ── Formatting ──────────────────────────────────────────────────────────────

  function fmt(n) {
    n = parseInt(n, 10) || 0;
    if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
    return n.toLocaleString('fr-FR');
  }

  // ── localStorage: liked state + Valenti wishlist sync ───────────────────────

  function isLiked(id) {
    try { return localStorage.getItem('ma_liked_' + id) === '1'; } catch (e) { return false; }
  }

  function syncHeaderWishlistColor() {
    try {
      var wl = JSON.parse(localStorage.getItem('localWishlist') || '[]');
      var btn = document.querySelector('.js-btn-wishlist:not([data-handle])');
      if (!btn) {
        var hc = document.querySelector('.js-wishlist-count');
        if (hc) btn = hc.closest('a, button');
      }
      if (btn) btn.classList.toggle('ma-wishlist-active', wl.length > 0);
    } catch (e) {}
  }

  function persist(id, handle, liked) {
    try {
      if (liked) {
        localStorage.setItem('ma_liked_' + id, '1');
        var wl = JSON.parse(localStorage.getItem('localWishlist') || '[]');
        if (wl.indexOf(handle) === -1) {
          wl.push(handle);
          localStorage.setItem('localWishlist', JSON.stringify(wl));
          var hc = document.querySelector('.js-wishlist-count');
          if (hc) hc.textContent = wl.length;
          var wb = document.querySelector('.js-btn-wishlist[data-handle="' + handle + '"]');
          if (wb && window.theme && window.theme.strings && window.theme.strings.wishlistIconAdded) {
            wb.innerHTML = window.theme.strings.wishlistIconAdded +
              '<span class="wishlist-text">' + (window.theme.strings.wishlistTextAdded || '') + '</span>';
          }
        }
        syncHeaderWishlistColor();
      } else {
        localStorage.removeItem('ma_liked_' + id);
      }
    } catch (e) {}
  }

  // ── sessionStorage cache (per product, 5-min TTL) ───────────────────────────

  function getCached(id) {
    try {
      var raw = sessionStorage.getItem('ma_kv_' + id);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      return obj.ts > Date.now() - CACHE_TTL ? obj.count : null;
    } catch (e) { return null; }
  }

  function setCached(id, count) {
    try {
      sessionStorage.setItem('ma_kv_' + id, JSON.stringify({ ts: Date.now(), count: count }));
    } catch (e) {}
  }

  // ── UI helpers ───────────────────────────────────────────────────────────────

  function toast(msg) {
    if (window.theme && window.theme.alert && typeof window.theme.alert.new === 'function') {
      window.theme.alert.new('', msg, 2000, 'notice');
    }
  }

  function pop(btn) {
    btn.classList.add('ma-pop');
    setTimeout(function () { btn.classList.remove('ma-pop'); }, 300);
  }

  // ── Batch fetch ──────────────────────────────────────────────────────────────

  function applyKvCounts(kvCounts, rowMap) {
    Object.keys(rowMap).forEach(function (id) {
      var row         = rowMap[id];
      var kvCount     = parseInt(kvCounts[id] || '0', 10);
      var liquidCount = parseInt(row.dataset.likeCount, 10) || 0;
      var currentLive = id in liveCounts ? liveCounts[id] : 0;
      // Jamais régresser : max(KV, metafield seed, count déjà affiché)
      var live = Math.max(kvCount, liquidCount, currentLive);
      liveCounts[id] = live;
      setCached(id, live);
      var countEl = row.querySelector('.ma-like-count');
      if (countEl) countEl.textContent = live > 0 ? fmt(live) : ''; maSyncLikeLabel(row);
    });
  }

  function fetchBatch(rows) {
    if (typeof fetch !== 'function') return;

    var rowMap  = {};
    var toFetch = [];

    rows.forEach(function (row) {
      var id = row.dataset.productId;
      if (!id) return;
      rowMap[id] = row;

      var cached = getCached(id);
      if (cached !== null) {
        // Apply from sessionStorage immediately — no network needed
        var liquidCount = parseInt(row.dataset.likeCount, 10) || 0;
        var live = Math.max(cached, liquidCount);
        liveCounts[id] = live;
        var countEl = row.querySelector('.ma-like-count');
        if (countEl) countEl.textContent = live > 0 ? fmt(live) : ''; maSyncLikeLabel(row);
      } else {
        toFetch.push(id);
      }
    });

    if (!toFetch.length) return;

    fetch(WORKER_URL + '/batch?ids=' + toFetch.join(','), { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.counts) applyKvCounts(data.counts, rowMap);
      })
      .catch(function () {
        // Network error: keep Liquid value, don't show 0
      });
  }

  // ── Row init ─────────────────────────────────────────────────────────────────

  function initRow(row) {
    if (row.dataset.maInit) return;  // déjà initialisé
    row.dataset.maInit = '1';
    var id          = row.dataset.productId;
    var handle      = row.dataset.productHandle;
    var liquidCount = parseInt(row.dataset.likeCount, 10) || 0;
    var likeBtn     = row.querySelector('.ma-like-btn');
    var countEl     = row.querySelector('.ma-like-count');
    var shareBtn    = row.querySelector('.ma-share-btn');
    if (!likeBtn || !countEl) return;

    // Read/write through liveCounts — falls back to Liquid until batch arrives
    function getCount() { return id in liveCounts ? liveCounts[id] : liquidCount; }
    function setCount(n) {
      liveCounts[id] = n;
      setCached(id, n);
      countEl.textContent = n > 0 ? fmt(n) : ''; maSyncLikeLabel(row);
    }

    // Initial render from Liquid (fast — no flash)
    countEl.textContent = liquidCount > 0 ? fmt(liquidCount) : ''; maSyncLikeLabel(row);
    var liked = isLiked(id);
    likeBtn.setAttribute('aria-pressed', liked ? 'true' : 'false');
    if (liked) likeBtn.classList.add('ma-liked');

    likeBtn.addEventListener('click', function () {
      liked = !liked;
      if (liked) {
        var preClickCount = getCount();
        setCount(preClickCount + 1);
        likeBtn.classList.add('ma-liked');
        likeBtn.setAttribute('aria-pressed', 'true');
        pop(likeBtn);
        persist(id, handle, true);
        toast('Ajouté à votre liste d\'envies ❤️');

        fetch(WORKER_URL + '/' + id + '/increment', {
          method: 'POST',
          credentials: 'omit',
          headers: { 'X-Like-Base': String(preClickCount) }
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && data.count != null) {
              // Jamais descendre en dessous du count optimiste déjà affiché
              setCount(Math.max(parseInt(data.count, 10), getCount()));
            }
          })
          .catch(function () {});

      } else {
        setCount(Math.max(0, getCount() - 1));
        likeBtn.classList.remove('ma-liked');
        likeBtn.setAttribute('aria-pressed', 'false');
        persist(id, handle, false);
      }
    });

    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var url = window.location.href;
        if (navigator.share) {
          navigator.share({ title: document.title, url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url)
            .then(function () { toast('Lien copié 🎨'); })
            .catch(function () {});
        }
      });
    }
  }

  // ── Entry point ──────────────────────────────────────────────────────────────

  function init() {
    var rows = Array.prototype.slice.call(
      document.querySelectorAll('.ma-like-row[data-product-id]')
    );
    rows.forEach(initRow);
    fetchBatch(rows);
    syncHeaderWishlistColor();
    observeNewRows();
  }

  // ── MutationObserver : click-to-load-more ───────────────────────────────────

  var _observing = false;
  function observeNewRows() {
    if (_observing || typeof MutationObserver === 'undefined') return;
    _observing = true;

    var pending = null;
    var observer = new MutationObserver(function (mutations) {
      var newRows = [];
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches('.ma-like-row[data-product-id]')) newRows.push(node);
          var nested = node.querySelectorAll('.ma-like-row[data-product-id]');
          for (var i = 0; i < nested.length; i++) newRows.push(nested[i]);
        });
      });

      newRows = newRows.filter(function (r) { return !r.dataset.maInit; });
      if (!newRows.length) return;

      // Debounce : regroupe les insertions rapides en un seul fetchBatch
      clearTimeout(pending);
      pending = setTimeout(function () {
        newRows.forEach(initRow);
        fetchBatch(newRows);
      }, 80);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  window.MassinartLikes.init = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
